import { drawerSlice } from './slice';

export const { openDrawer, closeDrawer } = drawerSlice.actions;
